<script lang="ts">
  // Hands an event to the device's own calendar, through the same downloadable file the
  // calendar card uses. Nothing is written to a calendar by us: the user confirms it in
  // their own application, which is the rule the spec already sets for calendar events.

  import { t } from '$lib/i18n/index.svelte';
  import { downloadText } from '$lib/media/download';
  import { calendarEventIcs } from '$lib/media/ics';

  import type { ElementContext } from '../context';

  let { ctx, eventId }: { ctx: ElementContext; eventId: string | undefined } = $props();

  const event = $derived(eventId === undefined ? undefined : ctx.resolveEvent(eventId));

  function save(): void {
    if (event === undefined) {
      return;
    }
    downloadText(
      calendarEventIcs(event, { accountId: ctx.accountId, sequence: ctx.sequence }),
      'text/calendar',
      `event-${event.eventId}.ics`,
    );
  }
</script>

<button
  type="button"
  disabled={event === undefined || event.status === 'cancelled'}
  onclick={save}
>
  {t('views.control.calendarAdd')}
</button>

<style>
  button {
    border: 1px solid var(--line);
    border-radius: 10px;
    background: var(--surface);
    color: var(--ink);
    font: inherit;
    padding: 9px 14px;
    cursor: pointer;
  }
  button:disabled {
    opacity: 0.5;
    cursor: default;
  }
</style>
